module.exports = __webpack_public_path__ + "static/media/website-modmemes.a6818824.png";